<template>
  <section class="hub-hero">
    <div class="hub-hero__text">
      <h1 class="hub-hero__title" v-html="getTitleBlock(page, 'hero', 'title')"></h1>
      <p class="hub-hero__description" v-html="getTitleBlock(page, 'hero', 'description')"></p>
      <OrangeFancyButtonWithArrowAnimation hash="#resources-form" class="hub-hero__button">
        {{ getKeyValueListBlockValue(page, 'hero-details', 'button') }}
      </OrangeFancyButtonWithArrowAnimation>
    </div>
    <HeroPreview />
  </section>
</template>

<script>
import HeroPreview from './hero-preview';
import { textBlock } from '@/entities/text-block';
import { RESOURCES_HUB_TEXT_PAGE } from '@/features/agent-resources/config';
import { OrangeFancyButtonWithArrowAnimation } from '@/shared/ui/form';

export default {
  mixins: [ textBlock ],
  components: { OrangeFancyButtonWithArrowAnimation, HeroPreview },
  data() {
    return {
      page: RESOURCES_HUB_TEXT_PAGE,
    };
  },
};
</script>

<style lang="scss" scoped>
.hub-hero {
  max-width: 1328px;
  margin: 0 auto;
  padding: 72px 24px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 48px;
  align-items: center;

  @media (max-width: 800px) {
    padding: 32px 16px 0;
  }

  &__text {
    flex: 1 1 520px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  &__title {
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(40px, 5.2vw, 68px);
    line-height: 1.08;
    color: #373A3D;

    ::v-deep span {
      background: linear-gradient(90deg, #4555CC, #CC5697 55%, #E67B53);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }
  }

  &__description {
    margin: 0;
    max-width: 440px;
    font-size: 19px;
    line-height: 28px;
    color: #4E5358;
  }

  &__button {
    width: auto;
    border-radius: 16px;
    box-shadow: 0 16px 48px rgba(235, 140, 66, 0.25);
  }
}
</style>
